import { loadPresets } from "../../lib/loadPresets";
import * as actions from "./actions";
import { ActionType, getType } from "typesafe-actions";
import { combineReducers } from "redux";
import { BookMultiOrder, BookPoint } from "./model/BookMultiOrder";
import { BookMultiState } from "./model/BookMultiState";
import { removeItemAtIndex } from "../../lib/helpers";
import { TimeWindowValidator } from "../../lib/validators/TimeWindowValidator";
import { LoadValidator } from "../../lib/validators/LoadValidator";

export type BookMultiAction = ActionType<typeof actions>;

const initialPoint: BookPoint = {
  address: {},
  loads: [loadPresets[0]],
  timewindow: [7, 17]
};

const initialOrder: BookMultiOrder = {
  date: undefined,
  singlePoint: initialPoint,
  multiPoints: [initialPoint],
  extras: []
};

const timeWindowValidator = new TimeWindowValidator();
const loadValidator = new LoadValidator();

export default combineReducers<BookMultiState, BookMultiAction>({
  order: (state = initialOrder, action) => {
    switch (action.type) {
      case getType(actions.selectMultiType):
        return { ...initialOrder, type: action.payload };
      case getType(actions.updateOrder):
        return loadValidator.orderWithValidLoads(
          timeWindowValidator.orderWithValidTimeWindows(action.payload)
        );
      case getType(actions.resetOrder):
        return initialOrder;
      case getType(actions.updateSinglePoint):
        return loadValidator.orderWithValidLoads(
          timeWindowValidator.orderWithValidTimeWindows({
            ...state,
            singlePoint: action.payload
          })
        );
      case getType(actions.updateMultiPoints):
        const newMultipoints = [...state.multiPoints];
        newMultipoints[action.payload.pointIndex] = action.payload.point;
        return loadValidator.orderWithValidLoads(
          timeWindowValidator.orderWithValidTimeWindows({
            ...state,
            multiPoints: newMultipoints
          })
        );
      case getType(actions.addPoint):
        return timeWindowValidator.orderWithValidTimeWindows({
          ...state,
          multiPoints: [...state.multiPoints, initialPoint]
        });
      case getType(actions.deletePoint):
        return timeWindowValidator.orderWithValidTimeWindows({
          ...state,
          multiPoints: removeItemAtIndex([...state.multiPoints], action.payload)
        });
      default:
        return state;
    }
  },
  isLoadingQuote: (state = false, action) => {
    switch (action.type) {
      case getType(actions.fetchQuoteAsync.request):
        return true;
      case getType(actions.fetchQuoteAsync.success):
        return false;
      case getType(actions.fetchQuoteAsync.failure):
        return false;
      default:
        return state;
    }
  },
  quote: (state = null, action) => {
    switch (action.type) {
      case getType(actions.resetQuote):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.fetchQuoteAsync.success):
        return action.payload;
      case getType(actions.fetchQuoteAsync.failure):
        return null;
      default:
        return state;
    }
  },
  isLoadingCreate: (state = false, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.request):
        return true;
      case getType(actions.createOrderAsync.success):
        return false;
      case getType(actions.createOrderAsync.failure):
        return false;
      default:
        return state;
    }
  },
  createdOrder: (state = null, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.success):
        return { ...action.payload };
      case getType(actions.resetOrder):
        return null;
      default:
        return state;
    }
  },
  quoteError: (state = null, action) => {
    switch (action.type) {
      case getType(actions.fetchQuoteAsync.request):
      case getType(actions.fetchQuoteAsync.success):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.fetchQuoteAsync.failure):
        return action.payload;
      default:
        return state;
    }
  },
  createError: (state = null, action) => {
    switch (action.type) {
      case getType(actions.createOrderAsync.request):
      case getType(actions.createOrderAsync.success):
      case getType(actions.resetOrder):
        return null;
      case getType(actions.createOrderAsync.failure):
        return action.payload;
      default:
        return state;
    }
  }
});
